export default __webpack_public_path__ + "media/zurb/fonts/PixelifySans-Regular-3e8e4ac8bbca86d20ea86f8f847a7744.woff2";